import { PathWithId } from "@constellation-academy/epic-ui";
import { DiscountActionEditPath } from "../discount-action-edit/discount-action-edit.paths";

export class ActiveDiscountActionsPath extends PathWithId<typeof ActiveDiscountActionsPath> {
	static readonly pathKey = "activeDiscountActions";
	static readonly pathName = "active-discount-actions";
	static readonly idKey = "discountActionId";
	static readonly childPaths = [DiscountActionEditPath];
}

export class ArchivedDiscountActionsPath extends PathWithId<typeof ArchivedDiscountActionsPath> {
	static readonly pathKey = "archivedDiscountActions";
	static readonly pathName = "archived-discount-actions";
	static readonly idKey = "discountActionId";
	static readonly childPaths = [DiscountActionEditPath];
}
